import { render } from "./OfferingsWatch.vue?vue&type=template&id=d6494644&scoped=true"
import script from "./OfferingsWatch.vue?vue&type=script&lang=js"
export * from "./OfferingsWatch.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d6494644"

export default script